export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11377.b5b97b0f.jpg";